import React from "react";
import { Redirect } from "react-router-dom";
import { APPID, APPVERSION, setLocalStorage } from "../common";
import { BASE_AXIOS } from "../config";
 
export const apiGetSASPResidencyProgram = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("appid", APPID);
    form.append("appversion", APPVERSION);

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getSASPResidencyProgram"
            },
            data: form
        });

        if (typeof response.data !== 'object') {
            return null
        }
        
        return response.data;   

    } catch (e) {
        throw e;
    }
}

export const apiSendSASPResidentAccess = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("residentid", data.residentid);
    form.append("programid", data.programid);
    form.append("accesslevel", 1);

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "sendSASPResidentAccess"
            },
            data: form
        });

        if (typeof response.data !== 'object') {
            return null
        }
        
        return response.data;   
    } catch (e) {
        throw e;
    }
}

export const apiGetSASPResidenctData= async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("residentid", data.residentid);
    form.append("programid", data.programid);
    form.append("accesslevel", data.accesslevel);

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getSASPResidentData"
            },
            data: form
        });

        if (typeof response.data !== 'object') {
            return null
        }
        
        return response.data;   
    } catch (e) {
        throw e;
    }
}

export const apiGetCmeYear = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("APPID", APPID);
    form.append("APPVERSION", APPVERSION);

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getCmeYears"
            },
            data: form
        });

        if (typeof response.data !== 'object') {
            return null
        }
        
        return response.data;   
    } catch (e) {
        throw e;
    }
}

export const apiGetSASPYears = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("APPID", APPID);
    form.append("APPVERSION", APPVERSION);

    if (typeof data.availableyears !== 'undefined') {
        form.append("availableyears", data.availableyears)
    } else {
        form.append('availableyears', '2012,2013')
    }

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getSASPYears"
            },
            data: form
        });
        
        return response.data;   
    } catch (e) {
        throw e;
    }
}

export const apiGetMessages = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("APPID", APPID);
    form.append("APPVERSION", APPVERSION);

    form.append("availableyears", data.availableyears ? data.availableyears : '2012,2013,2014,2015')

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getNotifications"
            },
            data: form
        });

        if (typeof response.data !== 'object') {
            return null
        }
        
        return response.data;   
    } catch (e) {
        throw e;
    }
}

export const apiGetAppReporting = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("APPID", APPID);
    form.append("APPVERSION", APPVERSION);

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getMySASPData"
            },
            data: form
        });
        
        return response.data;   
    } catch (e) {
        throw e;
    }
}

export const apiGetUserDetails = async (mcid, key, data) => {
    let form = new FormData();
    form.append("mcid", mcid);
    form.append("key", key);
    form.append("appid", APPID);
    form.append("appversion", APPVERSION);

    if (typeof data !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.pathname);
        form.append("pagevia", data.pagevia);
        form.append("action", data.action);
        form.append("os", data.os);
        form.append("ua", data.ua);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getUserDetails"
            },
            data: form
        });

        if (typeof response.data === 'string') {
            return (<Redirect to='/error' message='Error: Loading User Details'/>)
        }
        let local = JSON.stringify(response.data);
        setLocalStorage('sasp_user_details', local);
        const date = new Date ();
        localStorage.setItem('sasp_user_DT', date.getTime());

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const apiUpdateUser = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("allowshare", data.allowShare);
    form.append("allowsearch", data.allowSearch);
    form.append("allowleaderboard", data.allowLeaderboard);
    form.append("isDaily", data.isDaily);
    form.append("hideOldData", data.hideOldData);
    form.append("displayname", data.displayName);
    form.append("yst", data.yst);
    form.append("tl", data.tl);
    form.append("allowProgram", data.allowProgram ? 1 : 0);
    form.append("isResident", data.isResident ? data.allowProgram : 0);
    form.append("appversion", APPVERSION)

    if (typeof data.pkid !== 'undefined') {
        form.append("pkid", data.pkid);
        form.append('type', 'ACCESSREQUEST')
    }

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "editUserProfile"
            },
            data: form
        });

        return response.data;
    } catch (e) {
        throw e;
    }
}

export const apiGetLeaderboard = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("appid", APPID);
    form.append("appversion", APPVERSION);

    if (typeof data.timespan !== 'undefined') {
        form.append('timespan', data.timespan);
    }

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
    } 

    try {
        const leaderboardResults = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getLeaderboard"
            },
            data: form
        });

        return leaderboardResults.data;
    } catch (e) {
        throw (e);
    }
}

export const apiGetAccessList = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);

    if (typeof data.programid !== 'undefined' && data.programid !== null) {
        form.append('programid', data.programid);
    }

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const accessListResults = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getAccessList"
            },
            data: form
        });

        return accessListResults.data;
    } catch (e) {
        throw (e);
    } 
}

export const apiUpdateNotification = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("pkid", data.pkid);
    form.append("state", data.state);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const notifResults = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "updateNotification"
            },
            data: form
        });

        return notifResults.data;
    } catch (e) {
        throw (e);
    } 
}

export const apiGetDailyQuestion = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    if (typeof data.availableyears !== 'undefined' && typeof data.availableyears === 'string') {
        form.append('availableyears', data.availableyears);
    }
    
    try {
        const notifResults = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getDailyQuestion"
            },
            data: form
        });

        return notifResults.data;
    } catch (e) {
        throw (e);
    } 
}

export const apiRateApp = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const results = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "updateRateApp"
            },
            data: form
        });

        return results.data;
    } catch (e) {
        throw (e);
    } 
}

export const apiTrackPage = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid); 
    form.append("key", data.key);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
        
        if (typeof data.tracking.detail !== 'undefined') {
            form.append("detail", data.tracking.detail);
        }

        if (typeof data.tracking.detailvar !== 'undefined') {
            form.append("detailvar", data.tracking.detailvar);
        }

        if (typeof data.tracking.detailvar2 !== 'undefined') {
            form.append("detailvar2", data.tracking.detailvar2);
        }
    } 

    try {
        const results = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "trackUsage"
            },
            data: form
        });

        return results.data;
    } catch (e) {
        throw (e);
    } 
}